import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

const URL = `reports/check-dates`;
export const getCheckDates = (axios: IAxiosInstance) => {
  return async (params: ISchema["#/definitions/IGetCheckDatesQueryParams"]) => {
    const response = await axios.noRetry.get<
      ISchema["#/definitions/IGetCheckDatesResponseBody"]
    >(URL, { params });
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
